import { render, staticRenderFns } from "./LogoPathTitle.vue?vue&type=template&id=05f5ec3a&scoped=true&"
var script = {}
import style0 from "./LogoPathTitle.vue?vue&type=style&index=0&id=05f5ec3a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f5ec3a",
  null
  
)

export default component.exports